import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetolaturcab() {



  const cardData = {




keyword: "Pune to Latur Cab",

headingDescription: "Garud Cab Service provides comfortable and reliable Pune to Latur Cab Service for families, business travelers, students, professionals, couples, and groups planning a convenient long-distance journey. Customers can book chauffeur-driven Sedan, SUV, Ertiga, Innova, Innova Crysta, Tempo Traveller, and other suitable vehicles for one-way travel, round trips, business visits, family functions, educational travel, medical trips, and customized Latur travel plans. With experienced drivers, clean and well-maintained vehicles, comfortable seating, practical luggage space, flexible pickup locations across Pune, transparent pricing, and 24/7 customer assistance, Garud Cab Service makes the journey from Pune to Latur convenient and comfortable. Travelers can also customize their itinerary to cover important religious, historical, and nearby destinations according to their preferred schedule.",

topPlaces: [
  {
    title: "Latur City",
    description: "Latur is an important city in Maharashtra known for education, agriculture, business, healthcare, and regional commercial activities. Travelers from Pune frequently visit the city for professional work, family functions, educational purposes, and personal requirements. Garud Cab Service provides private chauffeur-driven cabs for direct travel with comfortable seating, practical luggage space, flexible pickup locations, and one-way or round-trip booking options."
  },
  {
    title: "Udgir Fort",
    description: "Udgir Fort is a historic fort in the Latur region known for its impressive fortifications, underground structures, temples, and historical significance. It is an interesting destination for travelers who enjoy Maharashtra's heritage and architecture. Customers traveling from Pune can include Udgir in their itinerary and enjoy private cab transportation with flexible sightseeing arrangements."
  },
  {
    title: "Ausa Fort",
    description: "Ausa Fort is a historic hill fort located near Latur and offers visitors an opportunity to explore the region's medieval heritage and traditional architecture. Its elevated location and surrounding landscape make it suitable for history enthusiasts and photographers. Garud Cab Service can arrange comfortable private transportation from Pune for travelers planning to explore Ausa and nearby attractions."
  },
  {
    title: "Hattibet Devarjan",
    description: "Hattibet Devarjan is a scenic and religious destination near Udgir in the Latur region, known for its hill surroundings and local spiritual significance. It offers a peaceful experience for devotees and travelers exploring the countryside. A private cab from Pune provides convenient transportation for families and small groups who want to include this destination in a customized Latur journey."
  },
  {
    title: "Nilanga",
    description: "Nilanga is an important town in the Latur district known for its regional commerce, educational activities, religious sites, and surrounding rural landscapes. Travelers may visit the area for business, family functions, or personal work. Customers can book a chauffeur-driven cab from Pune for comfortable door-to-door transportation with flexible travel timings and suitable vehicle options."
  },
  {
    title: "Deoni",
    description: "Deoni is a town in the Latur region surrounded by agricultural landscapes and local communities, making it a destination for family visits, business activities, and regional travel. Passengers traveling from Pune can choose a private cab for a direct and comfortable journey. Garud Cab Service offers flexible pickup and drop arrangements with professional drivers and practical luggage capacity."
  },
  {
    title: "Tuljapur",
    description: "Tuljapur is a major pilgrimage destination in Maharashtra and is home to the revered Tulja Bhavani Temple. Devotees traveling from Pune toward Latur can conveniently include Tuljapur in their religious itinerary. Garud Cab Service provides comfortable private transportation for families, senior citizens, and groups with options for one-way, return, and multi-destination journeys."
  },
  {
    title: "Akkalkot",
    description: "Akkalkot is an important spiritual destination associated with Shri Swami Samarth and attracts devotees throughout the year. Travelers visiting Latur can extend their journey to Akkalkot as part of a religious tour across southern Maharashtra. Customers can book a private cab from Pune with flexible travel plans and convenient transportation between pilgrimage destinations."
  },
  {
    title: "Nanded",
    description: "Nanded is a major religious and cultural destination in Maharashtra, particularly known for Takht Sachkhand Shri Hazur Sahib and its importance in Sikh pilgrimage. Travelers from Pune can combine Nanded with Latur for a longer regional journey. Garud Cab Service offers comfortable chauffeur-driven transportation with flexible one-way, round-trip, and customized multi-city travel options."
  },
  {
    title: "Parli",
    description: "Parli is a significant pilgrimage destination in Maharashtra and is known for the revered Vaijnath Temple, traditionally counted among the important Jyotirlinga sites. Devotees traveling from Pune can include Parli in a religious journey covering Latur and other nearby destinations. A private cab provides convenient door-to-door transportation with flexible sightseeing and return arrangements."
  }
],



"services": [
{
"name": "Pune to Latur Car Rental",
"description": "Book Pune to Latur Car Rental for comfortable and convenient intercity travel with professional chauffeurs and well-maintained vehicles. The service is suitable for families, business travelers, personal visits, long-distance journeys, airport transfers, and planned one-way or round-trip travel between Pune and Latur."
},
{
"name": "Pune to Latur Cab",
"description": "Choose Pune to Latur Cab for a comfortable private journey with convenient pickup and direct destination drop. Customers can select suitable vehicles for family trips, business travel, personal visits, and long-distance transportation with professional driver assistance throughout the journey."
},
{
"name": "Pune to Latur Taxi",
"description": "Book Pune to Latur Taxi for reliable chauffeur-driven transportation between the two cities. The service is suitable for individuals, families, corporate passengers, and travelers looking for comfortable AC travel with flexible pickup arrangements and convenient one-way or return journey options."
},
{
"name": "Pune to Latur Cab Service",
"description": "Choose Pune to Latur Cab Service for comfortable and dependable long-distance transportation with professional chauffeurs. The service supports one-way trips, round trips, family journeys, business travel, personal visits, and scheduled transportation from different areas of Pune to Latur."
},
{
"name": "Pune to Latur Taxi Service",
"description": "Book Pune to Latur Taxi Service for private intercity transportation with comfortable seating, AC vehicles, and experienced drivers. It is suitable for families, professionals, tourists, and individuals traveling between Pune and Latur for personal, business, or planned long-distance requirements."
},
{
"name": "Cab from Pune to Latur",
"description": "Reserve a Cab from Pune to Latur for convenient door-to-door transportation with a professional chauffeur. Customers can arrange private travel for family visits, business requirements, personal journeys, and long-distance trips while enjoying comfortable seating and practical luggage space."
},
{
"name": "Taxi from Pune to Latur",
"description": "Hire a Taxi from Pune to Latur for comfortable private transportation with scheduled pickup and direct destination drop. The service is suitable for individuals, families, corporate travelers, and passengers planning one-way or round-trip journeys between Pune and Latur."
},
{
"name": "Pune to Latur Outstation Cab",
"description": "Choose Pune to Latur Outstation Cab for long-distance travel with a professional chauffeur and well-maintained AC vehicle. The service is suitable for one-way transfers, return journeys, family trips, business travel, personal visits, and planned intercity transportation from Pune."
},
{
"name": "Pune to Latur Cab Booking",
"description": "Make Pune to Latur Cab Booking for scheduled private transportation with convenient pickup and destination drop facilities. Customers can choose suitable sedan, SUV, or larger vehicle options according to passenger requirements for family travel, corporate journeys, and long-distance trips."
},
{
"name": "Pune to Latur Taxi Booking Online",
"description": "Use Pune to Latur Taxi Booking Online for convenient advance travel arrangements without visiting a booking office. Schedule a chauffeur-driven vehicle for one-way or round-trip journeys, family travel, business visits, personal trips, and other planned transportation requirements."
},
{
"name": "Pune to Latur Cab Fare",
"description": "Check Pune to Latur Cab Fare according to the selected vehicle type, journey plan, pickup location, and one-way or round-trip requirement. Customers can choose from practical sedan and larger vehicle options for comfortable long-distance transportation between Pune and Latur."
},
{
"name": "Pune to Latur Taxi Fare",
"description": "Pune to Latur Taxi Fare can vary based on vehicle category, travel schedule, pickup point, and journey type. Choose a suitable chauffeur-driven vehicle for comfortable intercity travel with convenient pickup, direct drop, luggage space, and flexible one-way or return travel options."
},
{
"name": "Pune to Latur Cab Price",
"description": "Compare Pune to Latur Cab Price based on the selected vehicle and travel requirement before scheduling your journey. The service is suitable for families, individuals, corporate travelers, and passengers looking for comfortable AC transportation for planned long-distance travel."
},
{
"name": "Pune to Latur Taxi Charges",
"description": "Pune to Latur Taxi Charges depend on factors such as vehicle category, trip type, pickup location, and travel schedule. Customers can select a comfortable private taxi for one-way transfers, round trips, family journeys, business travel, and personal visits."
},
{
"name": "Best Pune to Latur Cab Service",
"description": "Choose the Best Pune to Latur Cab Service for comfortable chauffeur-driven transportation, convenient pickup, clean AC vehicles, and flexible journey options. The service is suitable for family travel, corporate transportation, personal visits, long-distance journeys, and planned intercity trips."
},
{
"name": "Cheap Pune to Latur Cab",
"description": "Book a Cheap Pune to Latur Cab for economical private transportation without compromising on basic travel comfort. Choose a suitable sedan or other vehicle option for one-way journeys, family trips, personal visits, business travel, and long-distance transportation between Pune and Latur."
},
{
"name": "Pune to Latur One Way Cab",
"description": "Reserve Pune to Latur One Way Cab for convenient point-to-point transportation without requiring a return journey. The service is suitable for relocation, personal visits, business travel, family transportation, and passengers who need a direct transfer from Pune to Latur."
},
{
"name": "Pune to Latur Round Trip Taxi",
"description": "Book Pune to Latur Round Trip Taxi for return transportation according to your planned travel schedule. Enjoy private AC travel with professional chauffeur service for family visits, business journeys, personal trips, weekend travel, and other planned return journeys."
},
{
"name": "Pune to Latur Innova Cab",
"description": "Choose Pune to Latur Innova Cab for comfortable group travel with spacious seating and practical luggage capacity. The vehicle is suitable for families and small groups traveling long distances from Pune to Latur for personal visits, business requirements, and family occasions."
},
{
"name": "Pune to Latur Innova Crysta Cab",
"description": "Book Pune to Latur Innova Crysta Cab for premium long-distance transportation with spacious interiors, comfortable seating, AC travel, and professional chauffeur service. It is suitable for families, corporate travelers, small groups, and passengers seeking an upgraded travel experience."
},
{
"name": "Pune to Latur Ertiga Cab",
"description": "Choose Pune to Latur Ertiga Cab for practical group transportation with comfortable seating and useful luggage capacity. The vehicle is suitable for families, friends, business travelers, and passengers looking for a convenient option for one-way or round-trip journeys."
},
{
"name": "Pune to Latur Sedan Cab",
"description": "Book Pune to Latur Sedan Cab for comfortable private travel with AC interiors, practical luggage space, and professional chauffeur service. Sedan options are suitable for couples, individuals, small families, and corporate passengers traveling between Pune and Latur."
},
{
"name": "Pune to Latur SUV Taxi",
"description": "Choose Pune to Latur SUV Taxi for spacious and comfortable long-distance transportation. SUVs are suitable for families, groups, and travelers carrying additional luggage who prefer extra cabin space for a convenient journey between Pune and Latur."
},
{
"name": "Pune to Latur AC Cab",
"description": "Reserve Pune to Latur AC Cab for comfortable travel in a climate-controlled vehicle with professional chauffeur service. The service is suitable for individuals, families, corporate passengers, and travelers planning long-distance one-way or round-trip journeys."
},
{
"name": "Pune to Latur Luxury Cab",
"description": "Choose Pune to Latur Luxury Cab for a more premium intercity travel experience with comfortable interiors, spacious seating, AC facilities, and professional chauffeur service. It is suitable for executive travel, family journeys, special trips, and passengers seeking enhanced road-trip comfort."
},
{
"name": "Pune Airport to Latur Cab",
"description": "Book Pune Airport to Latur Cab for convenient long-distance transportation from Pune Airport to Latur. The service provides scheduled pickup, professional chauffeur assistance, comfortable AC travel, and practical luggage space for business travelers, families, tourists, and individuals."
},
{
"name": "Hinjewadi to Latur Taxi",
"description": "Choose Hinjewadi to Latur Taxi for convenient intercity travel from Pune's major IT and residential area. The service is suitable for employees, families, business travelers, and individuals requiring comfortable chauffeur-driven transportation with scheduled pickup and direct destination drop."
},
{
"name": "Wakad to Latur Cab",
"description": "Book Wakad to Latur Cab for comfortable private transportation from Wakad to Latur with convenient pickup arrangements. The service is suitable for family travel, business visits, personal journeys, and long-distance trips with professional chauffeur service and comfortable AC vehicles."
},
{
"name": "Hadapsar to Latur Taxi",
"description": "Reserve Hadapsar to Latur Taxi for reliable intercity transportation with convenient pickup from residential, commercial, and business locations. The service supports family journeys, office travel, personal visits, and long-distance trips with comfortable seating and professional driver assistance."
},
{
"name": "Pimpri Chinchwad to Latur Cab",
"description": "Choose Pimpri Chinchwad to Latur Cab for convenient long-distance transportation from PCMC to Latur. Customers can arrange sedan, SUV, or larger vehicles for family travel, business journeys, personal visits, and one-way or round-trip transportation with professional chauffeurs."
},
{
"name": "Pune to Latur Business Travel Taxi",
"description": "Book Pune to Latur Business Travel Taxi for professionals traveling between Pune and Latur for meetings, office visits, projects, and corporate requirements. Enjoy scheduled pickup, comfortable AC travel, direct destination drop, and professional chauffeur service for business journeys."
},
{
"name": "Pune to Latur Family Trip Cab",
"description": "Choose Pune to Latur Family Trip Cab for comfortable private transportation with suitable seating and luggage space for family journeys. The service is ideal for visiting relatives, family functions, personal trips, and planned one-way or round-trip travel between Pune and Latur."
},
{
"name": "Pune to Latur Long Distance Taxi",
"description": "Reserve Pune to Latur Long Distance Taxi for comfortable intercity transportation with experienced chauffeurs and well-maintained vehicles. The service is designed for extended road journeys, family travel, corporate trips, personal visits, and other long-distance transportation needs."
},
{
"name": "Pune to Latur Night Travel Cab",
"description": "Book Pune to Latur Night Travel Cab for scheduled overnight transportation with a professional chauffeur and comfortable AC vehicle. The service is suitable for passengers who prefer night travel for business requirements, family visits, personal journeys, or planned long-distance trips."
},
{
"name": "Pune to Latur Outstation Taxi Service",
"description": "Choose Pune to Latur Outstation Taxi Service for convenient chauffeur-driven transportation between Pune and Latur. Customers can arrange private one-way or round-trip travel using suitable sedan, SUV, or larger vehicle options for families, professionals, and personal travel."
},
{
"name": "Pune to Latur Dzire Cab",
"description": "Book Pune to Latur Dzire Cab for an economical and comfortable sedan option suitable for individuals, couples, and small families. The vehicle provides AC travel, practical luggage space, and professional chauffeur service for planned one-way or round-trip journeys."
},
{
"name": "Pune to Latur Etios Cab",
"description": "Choose Pune to Latur Etios Cab for practical chauffeur-driven transportation with comfortable seating and AC interiors. It is suitable for individuals, couples, families, and business travelers looking for a convenient sedan option for long-distance travel."
},
{
"name": "Pune to Latur 7 Seater Cab",
"description": "Reserve Pune to Latur 7 Seater Cab for family and group transportation with additional passenger capacity and luggage space. The vehicle is suitable for relatives traveling together, small groups, family functions, and long-distance journeys requiring more seating than a standard sedan."
},
{
"name": "Pune to Latur Tempo Traveller",
"description": "Book Pune to Latur Tempo Traveller for comfortable group transportation with spacious seating and convenient luggage capacity. It is suitable for larger families, friends, corporate groups, pilgrimage trips, and organized journeys requiring shared travel between Pune and Latur."
},
{
"name": "Pune to Latur 12 Seater Traveller",
"description": "Choose Pune to Latur 12 Seater Traveller for group journeys requiring additional passenger capacity and comfortable road travel. The vehicle is suitable for family groups, corporate teams, tour groups, social events, and long-distance trips with professional chauffeur assistance."
},
{
"name": "Pune to Latur Minibus",
"description": "Reserve Pune to Latur Minibus for larger groups traveling together between Pune and Latur. The service provides spacious group transportation for corporate teams, family functions, tour groups, educational trips, and organized journeys requiring higher passenger capacity."
}
],
"tableData": [
["Pune to Latur Car Rental", "Pune to Latur Cab"],
["Pune to Latur Taxi", "Pune to Latur Cab Service"],
["Pune to Latur Taxi Service", "Cab from Pune to Latur"],
["Taxi from Pune to Latur", "Pune to Latur Outstation Cab"],
["Pune to Latur Cab Booking", "Pune to Latur Taxi Booking Online"],
["Pune to Latur Cab Fare", "Pune to Latur Taxi Fare"],
["Pune to Latur Cab Price", "Pune to Latur Taxi Charges"],
["Best Pune to Latur Cab Service", "Cheap Pune to Latur Cab"],
["Pune to Latur One Way Cab", "Pune to Latur Round Trip Taxi"],
["Pune to Latur Innova Cab", "Pune to Latur Innova Crysta Cab"],
["Pune to Latur Ertiga Cab", "Pune to Latur Sedan Cab"],
["Pune to Latur SUV Taxi", "Pune to Latur AC Cab"],
["Pune to Latur Luxury Cab", "Pune Airport to Latur Cab"],
["Hinjewadi to Latur Taxi", "Wakad to Latur Cab"],
["Hadapsar to Latur Taxi", "Pimpri Chinchwad to Latur Cab"],
["Pune to Latur Business Travel Taxi", "Pune to Latur Family Trip Cab"],
["Pune to Latur Long Distance Taxi", "Pune to Latur Night Travel Cab"],
["Pune to Latur Outstation Taxi Service", "Pune to Latur Dzire Cab"],
["Pune to Latur Etios Cab", "Pune to Latur 7 Seater Cab"],
["Pune to Latur Tempo Traveller", "Pune to Latur 12 Seater Traveller"],
["Pune to Latur Minibus", "Pune to Latur Innova Crysta"]
],



whychoose: [
  {
    WhyChooseheading: "Pune to Latur Cab for Comfortable Intercity Travel",
    WhyChoosedescription: "Garud Cab Service provides private Pune to Latur cab services for families, students, professionals, couples, and groups travelling for personal visits, business work, education, or other planned journeys."
  },
  {
    WhyChooseheading: "Private Journey with Convenient Door Pickup",
    WhyChoosedescription: "Start your trip from a convenient location in Pune and travel directly to your preferred destination in Latur without changing vehicles, making the journey practical when carrying luggage."
  },
  {
    WhyChooseheading: "A Convenient Option for Families",
    WhyChoosedescription: "Families can choose a suitable vehicle according to their group size, luggage requirements, and comfort preferences, allowing everyone to remain together throughout the journey."
  },
  {
    WhyChooseheading: "Useful for Education & Professional Travel",
    WhyChoosedescription: "The Pune to Latur cab service can be used for college visits, educational requirements, business meetings, office assignments, client appointments, and other professional travel."
  },
  {
    WhyChooseheading: "One-Way Cab for Direct Transportation",
    WhyChoosedescription: "Book a one-way cab when you need a direct drop in Latur for relocation, education, family visits, work requirements, or onward travel without arranging a return vehicle."
  },
  {
    WhyChooseheading: "Round-Trip Option for Scheduled Visits",
    WhyChoosedescription: "If your Latur visit has a planned return, a round-trip cab can be arranged according to your appointment, family schedule, business work, or preferred return timing."
  },
  {
    WhyChooseheading: "Flexible Vehicle Selection",
    WhyChoosedescription: "Choose an appropriate cab according to the number of passengers, luggage volume, and desired comfort level so your long-distance journey is suited to your travel requirements."
  },
  {
    WhyChooseheading: "Arrange Your Latur Cab with Garud",
    WhyChoosedescription: "Provide your Pune pickup point, Latur destination, travel date, passenger count, luggage details, preferred vehicle, and trip type to Garud Cab Service for booking assistance."
  }
]


};


const faqData = [
  {
    question: "Does Garud Cab Service provide Pune to Latur Cab Service?",
    answer: "Yes, Garud Cab Service provides private Pune to Latur cab services for families, students, professionals, couples, groups, and passengers travelling for personal or business purposes."
  },
  {
    question: "Can I book a one-way cab from Pune to Latur?",
    answer: "Yes, one-way cab service can be arranged for passengers who require direct transportation from Pune to their selected destination in Latur."
  },
  {
    question: "Can I book a round-trip Pune to Latur cab?",
    answer: "Yes, round-trip cab arrangements can be planned according to your Latur visit, business schedule, family plans, educational requirements, and preferred return date."
  },
  {
    question: "Is Pune to Latur cab suitable for families?",
    answer: "Yes, families and small groups can book a private cab according to their passenger count, luggage requirements, and preferred comfort level."
  },
  {
    question: "Can I use the cab for educational travel to Latur?",
    answer: "Yes, the service can be used for college visits, educational requirements, student travel, admission-related journeys, and other planned trips to Latur."
  },
  {
    question: "Can I use the cab for business travel?",
    answer: "Yes, Pune to Latur cab service can be used for meetings, office assignments, client visits, site work, professional appointments, and other business requirements."
  },
  {
    question: "Can I book a cab for relocation to Latur?",
    answer: "Yes, a private cab can be considered for relocation or personal shifting requirements, subject to the luggage capacity and seating space of the selected vehicle."
  },
  {
    question: "Can I get pickup from my home in Pune?",
    answer: "Yes, pickup can be arranged from your home, hotel, office, residential society, railway station area, or another preferred location in Pune."
  },
  {
    question: "Can I travel with luggage in the Pune to Latur cab?",
    answer: "Yes, passengers can carry luggage according to the available space in the selected vehicle. It is recommended to mention larger luggage requirements while booking."
  },
  {
    question: "How can I book a Pune to Latur Cab?",
    answer: "Share your Pune pickup location, Latur destination, travel date, passenger details, luggage requirements, preferred vehicle, and one-way or round-trip preference with Garud Cab Service."
  }
];


const testimonials = [
  {
    id: 1,
    name: "Mr. Tejas Jadhav",
    feedback: "I booked a Pune to Latur cab for a family visit. Having a private vehicle made the long journey more convenient, especially with our luggage and planned schedule.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Manisha Kulkarni",
    feedback: "We travelled to Latur for an important family function and booked a round-trip cab. The private travel arrangement made the journey easy for everyone in our group.",
    rating: 5
  }
];




















  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "Pune to Mumbai Airport Cab",
      link: "pune-to-mumbai-airport-cab-service",
    },
    {
      place: "/images/keyword/2.jpg",
      text: "Pune to Outstation Cabs",
      link: "Pune-to-Outstation-Cabs",
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Pune to Mahabaleshwar Cab",
      link: "pune-to-mahabaleshwar-cab-service",
    },
    {
      place: "/images/keyword/4.jpg",
      text: "Pune to Lonavala Cab",
      link: "pune-to-lonavala-cab-service",
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Pune to Matheran Cabs",
      link: "pune-to-matheran-cab-service",
    },
    {
      place: "/images/keyword/6.jpg",
      text: "Pune to 5 Jyotirlinga Darshan Cab",
      link: "pune-to-5-jyotirlinga-cab-service",
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Pune to Bhimashankar Cab",
      link: "pune-to-bhimashankar-cab-service",
    },
    {
      place: "/images/keyword/8.jpg",
      text: "Pune to Aurangabad Cab Service",
      link: "Pune-to-Aurangabad-Cab-Service",
    },
    {
      place: "/images/keyword/9.jpg",
      text: "Pune to Nashik Cab Service",
      link: "Pune-to-Nashik-Cab-Service",
    },
    {
      place: "/images/keyword/10.jpg",
      text: "Pune to Kolhapur Cab Service",
      link: "Pune-to-Kolhapur-Cab-Service",
    },
    {
      place: "/images/keyword/11.jpg",
      text: "Pune to Alibaug Cab",
      link: "Pune-to-Alibaug-Cab",
    },
    {
      place: "/images/keyword/12.jpg",
      text: "Pune to Goa Cab Service",
      link: "Pune-to-Goa-Cab-Service",
    },
    {
      place: "/images/keyword/13.jpg",
      text: "Goa to Pune Cabs",
      link: "Goa-to-Pune-Cabs",
    },
    {
      place: "/images/keyword/14.jpg",
      text: "Innova Crysta Cab in Pune",
      link: "Innova-Crysta-Cab-in-Pune",
    },
    {
      place: "/images/keyword/15.jpg",
      text: "Ertiga On Rent in Pune",
      link: "Ertiga-On-Rent-in-Pune",
    },
    {
      place: "/images/keyword/16.jpg",
      text: "Pune to Ashtavinayak Cabs",
      link: "pune-to-ashtavinayak-cab-service",
    },
    {
      place: "/images/keyword/17.jpg",
      text: "Pune to Goa Cabs",
      link: "Pune-to-Goa-Cabs",
    },
    {
      place: "/images/keyword/18.jpg",
      text: "Pune to Jyotirlinga Darshan Package",
      link: "Pune-to-Jyotirlinga-Darshan-Package",
    },
    {
      place: "/images/keyword/19.jpg",
      text: "Pune to Akkalkot Cabs",
      link: "Pune-to-Akkalkot-Cabs",
    },
    {
      place: "/images/keyword/20.jpg",
      text: "Pune to Pandharpur Cab",
      link: "Pune-to-Pandharpur-Cab",
    },
    {
      place: "/images/keyword/21.jpg",
      text: "Pune to Grishneshwar Jyotirlinga Cab",
      link: "Pune-to-Grishneshwar-Jyotirlinga-Cab",
    },
    {
      place: "/images/keyword/22.jpg",
      text: "Pune to Mumbai Cabs",
      link: "pune-to-mumbai-cab-service",
    },
    {
      place: "/images/keyword/23.jpg",
      text: "Pune to Alibag Cab",
      link: "Pune-to-Alibag-Cab",
    },
    {
      place: "/images/keyword/24.jpg",
      text: "Pune to Goa Cab Service",
      link: "Pune-to-Goa-Cab-Service",
    },
    {
      place: "/images/keyword/25.jpg",
      text: "Innova Crysta On Rent in Pune",
      link: "Innova-Crysta-On-Rent-in-Pune",
    },

  ];







const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Latur Cab",
  "image": "https://garudcabs.com/assets/images/pune-to-latur-cab.webp",
  "description": "Book Pune to Latur Cab with Garud Cab for safe, comfortable, and reliable intercity travel. Get Pune to Latur taxi and car rental services for one way trips, round trips, family journeys, business travel, and convenient city-to-city transportation with Sedan, Ertiga, SUV, Innova, and Innova Crysta cab options.",
  "brand": {
    "@type": "Brand",
    "name": "Garud Cab"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "7934"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://garudcabs.com/pune-to-latur-cab"
  }
};




  return (
    <div>




<Helmet>
  <title>Pune to Latur Cab | Taxi & Car Rental Service | +91 9970007784</title>

  <meta
    name="description"
    content="Book Pune to Latur Cab with Garud Cab for comfortable and reliable travel. Get Pune to Latur taxi and car rental services for one way, round trip, family, business, and intercity journeys with Sedan, Ertiga, SUV, Innova, and Innova Crysta cabs."
  />

  <meta
    name="keywords"
    content="Pune to Latur Car Rental, Pune to Latur Cab, Pune to Latur Taxi, Pune to Latur Cab Service, Pune to Latur One Way Cab, Pune to Latur Cab Booking, Pune to Latur Car Hire"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>




      <section className="page-banner">
        <div className="page-banner-container">
          <h2>
            {cardData.keyword}
          </h2>
        </div>
      </section>








      <section>
        <div className="container-fluid p-0" >
          <div className="row container-fluid px-md-2">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/57.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Garud Cabs Services: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

              <div className="topPlaces">

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>





              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div className="service-card" key={index}>
                    <div className="service-content">
                      <h4>{service.name}</h4>
                      <span className="line"></span>
                      <p>{service.description}</p>
                    </div>

                    <div className="service-icon">
                      <i className="fas fa-arrow-right"></i>
                    </div>
                  </div>
                ))}
              </div>

              <div className="keyword-grid">
                {cardData.tableData.flat().map((keyword, index) => (
                  <div key={index} className="keyword-item">
                    <span className="keyword-bullet">-</span>
                    {keyword}
                  </div>
                ))}
              </div>



              <div id="why-choose-section" className="why-choose-section">

                <h2 className="section-title text-dark">
                  Why Choose <span>Garud Cabs Services</span>
                </h2>

                <div className="bento-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div className="bento-card" key={index}>

                      <div className="bento-number">
                        {String(index + 1).padStart(2, "0")}
                      </div>

                      <h4>{item.WhyChooseheading}</h4>

                      <p>{item.WhyChoosedescription}</p>

                    </div>
                  ))}
                </div>

              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Garud Cabs Services </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fas fa-phone-alt"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919970007784 " className="pc-call">+91 9970007784 </a>
                    </div>
                    <div className="pc-list">
                      <a href="tel:+919970353709 " className="pc-call">+91 9970353709 </a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919970007784 "
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919970007784 " className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-envelope"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@garudcabs.com" className="pc-email">
                      booking@garudcabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-location-dot"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Garud Cabs Services</strong><br />
                      Office No.101 Anand Heights
                      Chandan Nagar, Kharadi, Pune,
                      Maharashtra, India-  411014




                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetolaturcab;